import { render, staticRenderFns } from "./ExchangeWelfwareConfirmPopup.vue?vue&type=template&id=b5dd99b2&scoped=true"
import script from "./ExchangeWelfwareConfirmPopup.vue?vue&type=script&lang=ts"
export * from "./ExchangeWelfwareConfirmPopup.vue?vue&type=script&lang=ts"
import style0 from "./ExchangeWelfwareConfirmPopup.vue?vue&type=style&index=0&id=b5dd99b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dd99b2",
  null
  
)

export default component.exports